import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { distanceBetween } from '../../../../../utils/helpers/distances'

import PropertyCard from '../../../../../../shared/components/Property/PropertyCard';

import { Label } from 'hosman-material';

import PROPERTIES from '../../../../../apiPublic/ressources/properties'

const HosmanProperties = ({ sale, comparableSales, comparableSaleProperties }) => {
  const [properties, setProperties] = useState([])

  useEffect(() => {
    if (comparableSaleProperties) {
      const propertyIds = comparableSales.map((cSale) => cSale.property_id)
      setProperties(comparableSaleProperties.filter((property) => propertyIds.includes(property.id)))
      return;
    }

    let isMounted = true;

    const fetchProperties = async () => {
      try {
        const responses = await Promise.all(
          comparableSales.map((sale) => PROPERTIES.getProperty(sale.property_id))
        );

        if (isMounted) {
          const propertyData = responses.map((response) => response.data);
          setProperties(propertyData);
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des propriétés', error);
      }
    };

    fetchProperties();

    return () => {
      isMounted = false;
      setProperties([]);
    };
  }, [comparableSales]);

  return (
    <div className='flex justify-center gap-6 flex-wrap mx-auto py-10'>
      {properties.map((property) => {
        return (
          <div key={property.id} className='w-72'>
            <PropertyCard
              property={property}
              stateLabel={property.sale.advert_label_sold && <Label color='bg-ih-green'>{property.sale.advert_label_sold}</Label>}
              hosmanLabel={!property.sale.advert_label_sold}
              centerLabel={<Label color='bg-ih-indigo'>A {distanceBetween(
                property.lat,
                property.lng,
                sale.property.lat,
                sale.property.lng
              )}</Label>}
              price={property.sale.accepted_offer_price || property.sale.price}
              areaPrice
            />
          </div>
        )
      })}
    </div>
  );
}

export default HosmanProperties;

HosmanProperties.propTypes = {
  sale: PropTypes.object.isRequired,
  comparableSales: PropTypes.array,
  comparableSaleProperties: PropTypes.array,
};
